export interface IHomeRuntimePolicyInput {
	path: string;
	hasNetworkParameter?: boolean;
}

/**
 * Keep the landing page runtime deferred until interaction. Route names can
 * transiently be unset during initial async navigation, while the resolved
 * path is stable and is the actual behavior boundary we care about.
 */
export const shouldStartDeferredRuntimeForRoute = ({
	path,
	hasNetworkParameter = false,
}: IHomeRuntimePolicyInput): boolean => path !== '/' || hasNetworkParameter;
